import { TabConfiguration } from '@shippypro/design-system-web/types';

export interface IBaseTabsProps {
  activeTab: TabConfiguration;
  activeTabIndex: number;
  setActiveTab: (value: number) => void;
  tabs: TabConfiguration[];
}
